module.exports = __webpack_public_path__ + "static/media/image (16).cdde6c31.jpg";